import React, { useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { useGameRealTimeManager } from '@/hooks/useGameRealTimeManager';

interface GameWorkflowAutomationProps {
  userId?: string;
  userRole: string;
  onWorkflowUpdate?: () => void;
}

export const GameWorkflowAutomation: React.FC<GameWorkflowAutomationProps> = ({
  userId,
  userRole,
  onWorkflowUpdate
}) => {
  const { cleanup } = useGameRealTimeManager({
    userId,
    onGameUpdate: onWorkflowUpdate,
    onGameStatusUpdate: onWorkflowUpdate,
    onRosterUpdate: onWorkflowUpdate,
    onConfirmationUpdate: onWorkflowUpdate,
    onPlayerStatusUpdate: onWorkflowUpdate
  });

  const processAutomatedWorkflow = useCallback(async () => {
    try {
      console.log('🤖 Processing automated workflow checks...');

      // Run basic game status checks 
      const { data, error } = await supabase
        .from('venue_games')
        .select('id, game_status, game_date, game_time')
        .in('game_status', ['pending', 'approved'])
        .limit(10);
      
      if (error) {
        console.error('❌ Workflow automation error:', error);
        return;
      }

      if (data && data.length > 0) {
        console.log(`✅ Found ${data.length} games to monitor`);
        onWorkflowUpdate?.();
      }

    } catch (error) {
      console.error('❌ Workflow automation failed:', error);
    }
  }, [onWorkflowUpdate]);

  // Run workflow automation every 30 seconds
  useEffect(() => {
    const interval = setInterval(processAutomatedWorkflow, 30 * 1000);
    
    // Run immediately
    processAutomatedWorkflow();
    
    return () => {
      clearInterval(interval);
      cleanup();
    };
  }, [processAutomatedWorkflow, cleanup]);

  // This component doesn't render anything - it's purely for automation
  return null;
};